import React from 'react';
import styled from 'styled-components';
import ModalClose from '@/assets/img/ModalClose.png';

const Button = styled.button`
  border: 0;
  padding: 0;
  display: block;
  position: absolute;
  z-index: 10;
  right: 10px;
  top: 10px;
  background: #0000;
  &:hover {
    outline: 0;
    box-shadow: none;
  }
`;

function CloseButton(props) {
  return (
    <Button {...props}>
      <img src={ModalClose} alt="Close" />
    </Button>
  );
}

export default CloseButton;
